import type { ComputedRef, InjectionKey } from "vue";

export type ZwMenuActivateOn = "click" | "mousedown";

export type ZwMenuContext = {
  close: () => void;
  activateOn: ComputedRef<ZwMenuActivateOn>;
};

export const zwMenuKey: InjectionKey<ZwMenuContext> = Symbol("zwMenu");
